import { Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';

@Injectable()
export class MatDatepickerEs extends MatDatepickerIntl {
  override calendarLabel = 'Calendario';
  override prevMonthLabel     = 'Mes anteiror';
  override nextMonthLabel = 'Mes siguiente';
  override openCalendarLabel = "Abrir calendario";
  override closeCalendarLabel = "Cerrar calendario";
  override nextYearLabel = "Año siguiente";
  override prevYearLabel = "Año anterior";
}

